import { Component, OnDestroy, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { GlobalOverlayComponent } from './shared/components/global-overlay/global-overlay.component';
import { MaintenanceService } from './core/maintenance/maintenance.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, GlobalOverlayComponent],
  templateUrl: './app.html',
})
export class App implements OnDestroy {
  private readonly maintenance = inject(MaintenanceService);

  constructor() {
    this.maintenance.startPolling();
  }

  ngOnDestroy(): void {
    this.maintenance.stopPolling();
  }
}
